<template>
  <w-divided-in-content-wrapper
    v-bind='$props'
    :style='style'
  >
    <slot name='component'>
      <component
        :is='expandableComponent'
        :value='expanded'
        @transisiton:started='transisitonPending = true'
        @transisiton:finished='transisitonPending = false'
      >
        <slot />
      </component>
    </slot>
  </w-divided-in-content-wrapper>
</template>

<script>
import WorkDividedInContentWrapperColumn from '@/components/global_components/layout/WorkDividedInContentWrapperColumn';

export default {
  name: "WorkDividedInContentWrapperExpandableColumn",
  props: {
    ...WorkDividedInContentWrapperColumn.props,
    expanded: { type: Boolean, required: true },
    expandableComponent: { type: String, default: 'w-expandable-x' }
  },
  data() {
    return {
      transisitonPending: false
    };
  },
  computed: {
    style() {
      if (this.expanded === false && this.transisitonPending === false) {
        return 'display: none;';
      }
      return '';
    }
  }
}
</script>
